import type { TextFieldProps } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { MenuItem } from '@mui/material';

import { Field } from 'src/components/hook-form';

export enum SCHEDULING_MODE {
  AI = 'AI',
  MANUAL = 'MANUAL',
}

type Props = TextFieldProps & {
  name: string;
};

export const SchedulingMode = ({ name, ...props }: Props) => {
  const { t } = useTranslation('standards');
  return (
    <Field.Select name={name} {...props} size="small">
      {Object.keys(SCHEDULING_MODE).map((key) => (
        <MenuItem key={`${name}.${key}`} value={key}>
          {t(`schedulingMode.${key.toLowerCase()}`)}
        </MenuItem>
      ))}
    </Field.Select>
  );
};
